import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { useOnboardingCallActionShallowStore } from '../hooks/use-onboarding-call-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useViewPatientContextAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();
  const { setPendingTask } = useOnboardingCallActionShallowStore('setPendingTask');

  return {
    isEnabled: true,
    isLoading: false,
    onSelect: () => {
      setPendingTask(OnboardingBaseTask.BASE_TASK_VIEW_PATIENT_CONTEXT);
      navigate({ to: '/calls/call-history' });
      onClose();
    },
  };
}
